"use client";

import { useState } from "react";
import type { Award } from "@/lib/conditions/awards-types";

export function Methodology({ awards }: { awards: Award[] }) {
  const [open, setOpen] = useState(false);

  return (
    <section className="border-t border-border-light pt-12 mt-16 md:mt-24">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-3 text-[14px] font-semibold text-navy cursor-pointer bg-transparent border-none font-sans p-0 hover:text-gold transition-colors min-h-[44px]"
        aria-expanded={open}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`transition-transform ${open ? "rotate-90" : ""}`}
          aria-hidden="true"
        >
          <polyline points="9 18 15 12 9 6" />
        </svg>
        How each award is calculated
      </button>

      {open && (
        <div className="mt-6 space-y-6 max-w-[720px]">
          {awards.map((award) => (
            <div key={award.id}>
              <h4 className="text-[14px] font-semibold text-navy mb-1">
                {award.name}
              </h4>
              <p className="text-[13px] text-text-muted leading-[1.6]">
                {award.methodology}
              </p>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
